import { studySongModalActionTypes } from './Constants';

const initialState = {
	open: false,
};

export default function studySongModalReducer(state = initialState, action) {
	const { type, payload } = action;
	const { open } = payload || {};

	switch (type) {
		case studySongModalActionTypes.TOGGLE_STUDY_SONG_MODAL:
			return {
				...state,
				open,
			};

		default:
			return state;
	}
}
